import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

class HeadingHome {
  constructor() {
    this._init();
  }

  _init() {
    const swiperOptions = {
      modules: [Autoplay, EffectFade],
      direction: 'horizontal' as const,
      speed: 1000,
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      preventInteractionOnTransition: true,
      loop: true,
      effect: 'fade' as const,
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        disableOnInteraction: false,
      },
    };

    new Swiper('.heading-home__swiper--1', {
      ...swiperOptions,
      autoplay: {
        ...swiperOptions.autoplay,
        delay: 2500,
      },
    });

    new Swiper('.heading-home__swiper--2', {
      ...swiperOptions,
      autoplay: {
        ...swiperOptions.autoplay,
        delay: 3500,
      },
    });

    new Swiper('.heading-home__swiper--3', {
      ...swiperOptions,
      autoplay: {
        ...swiperOptions.autoplay,
        delay: 4500,
      },
    });
  }
}

export const headingHome = new HeadingHome();
